/**
 * Sorts an array of items based on a string property.
 *
 * @template T The type of the array elements.
 * @template K The type of the property to sort by.
 * @param array The array of items to sort.
 * @param property The property to sort by.
 * @returns The sorted array.
 */
export const sortArrayByProperty = <T, K extends keyof T>(
	array: T[],
	property: K
): T[] => {
	return array.slice().sort((a, b) => {
		const valueA = String(a[property]);
		const valueB = String(b[property]);
		return valueA.localeCompare(valueB);
	});
};
